module.exports = __webpack_public_path__ + "f737c68af1de490b4695150046aa2ba3.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/logos/workshop.svg
 ** module id = 440
 ** module chunks = 0
 **/